// @flow

import React, { Component } from 'react';
import { Label, FormGroup } from 'reactstrap';

import withFlightSearchParams from '../../../HOCs/withFlightSearchParams';

import type { UpdateFlightSearchParms } from '../flowTypes';

type Props = {
  searchParams: {
    nationality: string,
  },
  updateFlightSearchParms: UpdateFlightSearchParms,
};

class NationalityInput extends Component<Props> {
  render() {
    const {
      searchParams: { nationality },
    } = this.props;
    return (
      <div className="col-12">
        <FormGroup>
          <Label className="title">Nationality</Label>
          <div className="input-group">
            <select
              className="form-control"
              onChange={this.handleInputChange}
              value={nationality}
            >
              <option value="NP">Nepali</option>
              <option value="IN">Indian</option>
              <option value="US">Other</option>
            </select>
          </div>
        </FormGroup>
      </div>
    );
  }
  handleInputChange = event => {
    const val = event.target.value;
    const { updateFlightSearchParms } = this.props;
    updateFlightSearchParms({ parameter: 'nationality', value: val });
  };
}
export default withFlightSearchParams(NationalityInput);



// WEBPACK FOOTER //
// ./src/components/Flights/SearchInput/NationalityInput.jsx